import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dot-elastic',
  templateUrl: './dot-elastic.component.html',
  styleUrls: ['./dot-elastic.component.scss']
})
export class DotElasticComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
